import { setupRouter } from '@/router'
import { setupStore } from '@/store'
import setupPlugin from '@/plugins'
import { createApp } from 'vue'
import App from '@/App.vue'
import request from '@/utils/request'
import { baseUrl } from '@/utils/request'
// 挂载到window对象上
if (typeof window !== 'undefined') {
  window.request = request
  window.baseUrl = baseUrl
}


const boot = () => {
  const app = createApp(App)
  setupStore(app)
  setupRouter(app)
  setupPlugin(app)
  console.log('注册的组件:', app._context.components)
  app.mount('#app')
  return app
}

const webApp = boot()

// 覆盖鼠标滑动
document.body.addEventListener(
  'wheel',
  (e) => {
    if (e.ctrlKey) {
      if (e.deltaY < 0) {
        e.preventDefault()
        return false
      }
      if (e.deltaY > 0) {
        e.preventDefault()
        return false
      }
    }
  },
  { passive: false },
);
